import { useJsApiLoader } from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';

export const useGoogleComponent = (
    lat: number,
    lng: number,
    onCoordinates?: (value: { latitude: number; longitude: number }) => void
) => {
    const googleMapsApiKey = ENV.SMTR_GOOGLE_MAP_API_KEY;

    if (!googleMapsApiKey) {
        throw new Error('Google Maps API key is not defined');
    }

    const containerStyle = {
        width: '100%',
        height: '100%',
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey,
    });

    const [marker, setMarker] = useState({ lat, lng });
    const [map, setMap] = useState<google.maps.Map | null>(null);

    useEffect(() => {
        setMarker({ lat, lng });
    }, [lat, lng]);

    const handleMarkerDragEnd = (event: google.maps.MapMouseEvent) => {
        onCoordinates({
            latitude: event.latLng.lat(),
            longitude: event.latLng.lng(),
        });

        setMarker({
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        });
    };

    const onLoad = React.useCallback(function callback(map: google.maps.Map) {
        map.setCenter({ lat, lng });
    }, []);

    const onUnmount = React.useCallback(function callback(map: google.maps.Map) {
        setMap(null);
    }, []);
    return { containerStyle, isLoaded, marker, handleMarkerDragEnd, onLoad, onUnmount };
};
